// Wait until Mida anti-flicker (body opacity:0 / #abhide) clears before create_intent fetch.
// Early fetch during opacity:0 correlates with iOS "Load failed".
export function waitForCheckoutPageReady(maxWaitMs = 2500) {
  return new Promise(resolve => {
    const startedAt = performance.now()
    const deadline = startedAt + maxWaitMs

    const isReady = () => {
      if (document.getElementById("abhide")) return false
      const bodyOpacity = window.getComputedStyle(document.body).opacity
      if (bodyOpacity === "0") return false
      return document.visibilityState !== "hidden"
    }

    const finish = antiFlickerCleared => {
      resolve({
        waitTimeMs: Math.round(performance.now() - startedAt),
        antiFlickerCleared,
        maxWaitMs,
      })
    }

    const tick = () => {
      if (isReady()) {
        finish(true)
        return
      }
      if (performance.now() >= deadline) {
        finish(false)
        return
      }
      requestAnimationFrame(tick)
    }

    if (document.readyState === "complete") {
      tick()
    } else {
      window.addEventListener("load", tick, { once: true })
    }
  })
}

export function checkoutPageReadyDiagnostics() {
  return {
    abhide_present: Boolean(document.getElementById("abhide")),
    body_opacity: window.getComputedStyle(document.body).opacity,
    visibility_state: document.visibilityState,
    navigator_online: typeof navigator.onLine === "boolean" ? navigator.onLine : null,
  }
}
